import React from 'react'
let PropTypes = React.PropTypes
import ReactNotify from 'react-notify'
import * as ReactNotifyCSS from '../../shared/ReactNotify/ReactNotify.css'
import api from '../../apiClient/v1'
import { TablaZonas } from './TablaZonas.jsx'

/*Nombre de clase debe ser igual a la definida en boot-client*/
export class MantenedorCaptadoresZonas extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            captadores: this.props.captadores,
            comunasSelect: this.props.comunas,
            // Por defecto seleccionar SEI SEI
            idCaptador: "1",
            // Por defecto seleccionar Algarrobo
            // Valor defecto es 0
            valor: 0,
            cutComuna: "5602",
            comunas: [],
            operadores: [],
            editandoValor: false,
            error: {}
        }
        this.ajaxErrorHandler = (errorTitle)=>{
            return (err)=>{
                if(err.status==500)
                    return this.refs.notificator.error("Error crítico en el servidor", "Contáctese con el departamento de informática.", 4*1000);
                // en otro error, buscar el cuerpo del mensaje
                let msgs = _.values(err.data).join('. ')
                console.log(err)
                console.log(errorTitle, err.data)
                this.refs.notificator.error(errorTitle, msgs, 4*1000);
            }
        }
        this.seleccionarCaptador = (evt)=>{
            const idCaptador = evt.target.value;
            this.setState({
                idCaptador: idCaptador,
                comunas: []
            }, ()=>{
                this.fetchZonas()
            })
        }
        this.seleccionarComuna = (evt)=>{
            const cutComuna = evt.target.value;
            this.setState({
                cutComuna: cutComuna
            })
        }
        this.onChangeValor = (evt)=>{
            const valor = evt.target.value;
            this.setState({
                valor: valor
            })
        }
        this.fetchZonas = ()=>{
            api.captador(this.state.idCaptador).getZonas()
                .then(data=>{
                    this.setState({comunas: data})
                })
                .catch(this.ajaxErrorHandler('Error al buscar zonas'))
        }
        this.editarValor = (zona, valor)=>{
            let request = api.captador(this.state.idCaptador).actualizarValor(zona,valor)
            request   
                .then(()=> this.fetchZonas(), 
                           this.refs.notificator.success("Cambio en valor", "Valor editado correctamente", 4*1000)
            )
                .catch(this.ajaxErrorHandler('Error al editar valor'))
            return request
        }
        this.asociarZona = ()=>{
            let request = api.captador(this.state.idCaptador).asociarZona(this.state.cutComuna, this.state.valor)
            request
                .then(()=> this.fetchZonas())
                .catch(this.ajaxErrorHandler('Error al asociar zona'))
            return request
        }
        this.guardar = (evt)=>{
            evt.preventDefault()
            this.setState(()=>{
                this.asociarZona()
                    .then(()=>{
                        this.refs.notificator.success("Asociar zona", "Zona asociada correctamente", 4*1000)
                    })
                    .catch(error=>{
                        this.setState({error: error.data})
                    })
            })
        }
    }
    componentWillMount(){
        this.fetchZonas()
    }
    render(){
        return(
            <div>
                <div className="row">
                    <ReactNotify ref='notificator' className={ReactNotifyCSS}/>
                    <div className="col-md-offset-4 col-md-6">
                        <h1>Captadores por zonas</h1>
                    </div>
                </div>
                <SelectorCaptador
                    idCaptadorSeleccionado={this.state.idCaptador}
                    seleccionarCaptador={this.seleccionarCaptador}
                    captadores={this.state.captadores}
                />
                <div className="row">
                    <div className="col-md-7">
                        <label>Zonas de captador</label>
                        <TablaZonas
                            zonas={this.state.comunas}
                            editarValor={this.editarValor}
                        />
                    </div>
                    <div className="col-md-2 col-md-offset-2">
                        <label>Asociar nueva Comuna</label>
                        <NuevaZona
                            comunas={this.state.comunasSelect}
                            seleccionarComuna={this.seleccionarComuna}
                            onChangeValor={this.onChangeValor}
                            valorDefecto={this.state.valor}
                            guardar={this.guardar}
                        />    
                    </div>    
                </div>
            </div>
        )
    }
}
const SelectorCaptador = ({idCaptadorSeleccionado, seleccionarCaptador, captadores})=>
    <div className="row">
        <div className="col-sm-2 form-group ">
            <label className="control-label" htmlFor="captador">Seleccione Captador</label>
            <select className="form-control" name="captador"
                value={idCaptadorSeleccionado}
                onChange={seleccionarCaptador}
            >
                {captadores.map(captador=>
                    <option key={captador.id} value={captador.id}>{`${captador.nombre1} ${captador.apellidoPaterno}`}</option>
                )}
            </select>
        </div>
    </div>

const NuevaZona = ({comunas, seleccionarComuna, onChangeValor, valorDefecto, guardar})=>
    <form onSubmit={guardar}>
        <select className="form-control"
            value={undefined}
            onChange={seleccionarComuna}
        >
            {comunas.map(comuna=>
                <option key={comuna.cutComuna} value={comuna.cutComuna}>{`${comuna.nombre}`}</option>
            )}
       </select>     
        <label className="control-label">
        Precio:
        <input type="number" className="form-control" onChange={onChangeValor} value={valorDefecto}/>
        </label>
        <input type="submit" value="Guardar" className="btn btn-success"/>
    </form>
MantenedorCaptadoresZonas.propTypes = {
    captadores: PropTypes.array,
    provincias: PropTypes.array
}


// WEBPACK FOOTER //
// ./frontEnd/admin/mantenedorCaptadoresZonas/captadoresZonas.jsx